import {
    b64DecodeUnicode,
    cookieExistiert,
    cookieWertAuslesen,
    istMobil,
    scriptElementErzeugen,
    sleep,
    uriErstellen
} from "../../assets/js/utils.js";

class FeedbackAds extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.removeAttribute("data-js");
        // Sonst Zenloop initialisieren
        this.initZenloop();
        // Wir brauchen einen Mutation Observer, um Events für benutzerdefinierte Anpassungen registrieren zu können
        // Da Zenloop die entsprechende Elemente (z.B. Scores) jedes mal aus dem DOM entfernt, 
        // müssen wir z.B. im Fall vom Zurück-Button jedes mal einen neuen Listener registrieren.
        this.initMutationObserver();
    }

    initZenloop() {
        this.zenloopKonfiguration();
        this.zenloopWrapper = this.querySelector(".zenloop-wrapper");
        this.zenloopScriptUri = uriErstellen(this.zenloopApiUri, {
            "survey": istMobil() ? this.surveyHashMobile : this.surveyHashDesktop
        });
        this.scriptElement = scriptElementErzeugen(this.zenloopScriptUri, "async", "zl-website-overlay-loader");
        this.zenloopWrapper.appendChild(this.scriptElement);
    }

    zenloopKonfiguration() {
        Zenloop.recipient = {};
        Object.assign(Zenloop.recipient, {
            identity_type: "custom",
            properties: {
                mandant: this.mandant,
                artikelId: this.artikelId,
                matnr: this.matnr,
                werkId: this.werkId,
                shopId: this.shopId,
                shopLabel: this.shopLabel,
                verkaufsrang: this.verkaufsrang,
                fuehrendeKategorieId: this.fuehrendeKategorieId,
                geraeteTyp: istMobil() ? "Mobil" : "Desktop",
                titel: this.titel,
                ean: this.ean,
                abTest: this.adsAbtest,
                darstellung: this.darstellung
            }
        });
        if (cookieExistiert("KUNDE")) this.kundenIdentitaetZuweisen();
        if (cookieExistiert("SBEKUKL")) this.kundenInformationenZuweisen();
        if (cookieExistiert("KUSUSAN")) this.suchbegriffeZuweisen();
        if (localStorage.getItem("cid") !== null) this.analyticsCidZuweisen();
    }

    kundenIdentitaetZuweisen() {
        this.kundenNummer = atob(cookieWertAuslesen("KUNDE"));
        Zenloop.recipient.identity = this.kundenNummer.substr(0, this.kundenNummer.indexOf(":"));
    }

    kundenInformationenZuweisen() {
        this.kundenInformationen = JSON.parse(`${atob(cookieWertAuslesen("SBEKUKL"))}`);
        Object.assign(Zenloop.recipient.properties, {
            kundensegmente: this.kundenInformationen.cl,
            anrede: this.kundenInformationen.an,
            plz: this.kundenInformationen.pl
        })
    }

    suchbegriffeZuweisen() {
        this.suchbegriffe = b64DecodeUnicode(cookieWertAuslesen("KUSUSAN")).split('\u{2634}');
        this.suchbegriffe.shift(0);
        this.suchbegriffe.forEach((el, index) => {
            Zenloop.recipient.properties[`suchbegriff${index}`] = el;
        })
    }

    analyticsCidZuweisen() {
        Object.assign(Zenloop.recipient.properties, { 
            cid: localStorage.getItem("cid")
        });
    }

    initMutationObserver() {
        const options =  {
            childList: true,
            subtree: true,
            attributes: true
        };
        const mutationObserver = new MutationObserver(this.mutationsVerarbeiten.bind(this));
        mutationObserver.observe(this.querySelector(".zenloop-wrapper"), options);
    }

    mutationsVerarbeiten(mutationsList, observer) {
        for (const mutation of mutationsList) {
            // EventListener mit der once Option nach einer Ausführung sofort wieder entfernen, 
            // da Zenloop die entsprechenden Elemente beim Aktualisieren des UI aus dem DOM entfernt
            // und nur bei Bedarf wieder rendert.
            // 1. Scores/Emojis
            // 2. Submit Button
            if (mutation.target.querySelector(".zl-score-page")) {
                this.querySelectorAll(".zl-score").forEach((score) => {
                    score.addEventListener("click", this.scoreKlickVerarbeiten.bind(this), { once: true });
                });
            };
            if (mutation.target.querySelector(".zl-answer-page")) {
                this.querySelector(".zl-submit").addEventListener("click", () => this.umfrageSchritt = 3, { once: true });
                // Observer kann im letzten Schritt beendet werden
                // Hinweis: Wenn wir für zukünftige Umfragen den "Zurück Button" nutzen wollen, darf der Observer nicht beendet werden. 
                observer.disconnect();
            };
        }
    }

    async scoreKlickVerarbeiten() {
        this.skeleton = this.querySelector(".skeleton");
        try {
            this.skeleton.setAttribute("data-status", "loading");
            this.umfrageSchritt = 2;
            await sleep(800);
        } catch (error) {
            console.error(error);
        } finally {
            this.skeleton.removeAttribute("data-status");
        }
    }

    set umfrageSchritt(neuerWert) {
        this.setAttribute("data-aktiver-schritt", neuerWert);
    }

    get zenloopApiUri() {
        return this.dataset.zenloopApiUri;
    }

    get surveyHashMobile() {
        return this.dataset.surveyHashMobile;
    }

    get surveyHashDesktop() {
        return this.dataset.surveyHashDesktop;
    }

    get mandant() {
        return this.dataset.mandant;
    }

    get matnr() {
        return this.dataset.matnr;
    }

    get artikelId() {
        return this.dataset.artikelId;
    }

    get werkId() {
        return this.dataset.werkId;
    }

    get shopId() {
        return this.dataset.shopId;
    }

    get shopLabel() {
        return this.dataset.shopLabel;
    }

    get verkaufsrang() {
        return this.dataset.verkaufsrang;
    }

    get fuehrendeKategorieId() {
        return this.dataset.fuehrendeKategorieId;
    }

    get titel() {
        return this.dataset.titel;
    }

    get ean() {
        return this.dataset.ean;
    }

    get adsAbtest() {
        return this.dataset.adsAbtest;
    }

    get darstellung() {
        return this.dataset.darstellung;
    }
}

if (!customElements.get("feedback-ads")) {
    customElements.define("feedback-ads", FeedbackAds);
}
